
<script>
import moment from "moment";
import Icono from "../Icono/Icono";
import Push from "push.js";
import { actualizarNotificacion } from "../../apiService/request/Notificaciones";

export default {
  created() {
    if (!Push.Permission.has()) {
      Push.Permission.request();
    }

    this.$store.dispatch("initNotificaciones");
  },
  data() {
    return {
      iconoNotificaciones:
        "M37,35H7c-0.6,0-1-0.4-1-1v-2c0-2,0.9-3.9,2.4-5.2c2.6-2.3,3.6-4.4,3.6-7.2V14c0-4.1,2.4-7.6,6.1-9.2C18,4.5,18,4.3,18,4c0-1.2,0.5-2.3,1.4-3c0.9-0.8,2-1.1,3.2-1c1.6,0.2,2.9,1.4,3.3,3C26,3.6,26,4.2,25.9,4.8C29.6,6.4,32,9.9,32,14v5.5c0,2.8,1.1,4.9,3.6,7.2h0C37.1,28.1,38,30,38,32v2C38,34.6,37.6,35,37,35z M8,33h28v-1c0-1.4-0.6-2.8-1.7-3.7c-3-2.7-4.3-5.3-4.3-8.7V14c0-3.5-2.3-6.6-5.7-7.6c-0.3-0.1-0.5-0.3-0.6-0.6s-0.1-0.6,0-0.9C24,4.5,24.1,4,23.9,3.5C23.7,2.7,23,2.1,22.3,2c-0.6-0.1-1.2,0.1-1.6,0.5C20.2,2.9,20,3.4,20,4c0,0.3,0.1,0.6,0.2,0.9c0.1,0.3,0.2,0.6,0,0.9s-0.3,0.5-0.6,0.6c-3.4,1-5.7,4.1-5.7,7.6v5.5c0,3.4-1.3,6-4.3,8.7C8.6,29.2,8,30.6,8,32V33z M22,44c-3.3,0-6-2.7-6-6c0-0.6,0.4-1,1-1h10c0.6,0,1,0.4,1,1C28,41.3,25.3,44,22,44z M18.1,39c0.4,1.7,2,3,3.9,3s3.4-1.3,3.9-3H18.1z M44,0v44 M0,0v44",
      iconoBorrarNotificacion:
        "M37,4h-8V1c0-0.6-0.4-1-1-1H16c-0.6,0-1,0.4-1,1v3H7C6.4,4,6,4.4,6,5v4c0,0.6,0.4,1,1,1h1.1L10,43.1c0,0.5,0.5,0.9,1,0.9h22c0.5,0,1-0.4,1-0.9L35.9,10H37c0.6,0,1-0.4,1-1V5C38,4.4,37.6,4,37,4z M17,2h10v2H17V2z M32.1,42H11.9l-1.9-32h23.9L32.1,42z M36,8H8V6h28V8z M21,35V16c0-0.6,0.4-1,1-1s1,0.4,1,1v19c0,0.6-0.4,1-1,1S21,35.6,21,35z M27,34.9l1-19c0-0.6,0.5-1,1.1-0.9c0.6,0,1,0.5,0.9,1.1l-1,19c0,0.5-0.5,0.9-1,0.9c0,0,0,0-0.1,0C27.4,36,27,35.5,27,34.9z M15,35.1l-1-19c0-0.6,0.4-1,0.9-1.1c0.5,0,1,0.4,1.1,0.9l1,19c0,0.6-0.4,1-0.9,1.1c0,0,0,0-0.1,0C15.5,36,15,35.6,15,35.1z M44,0v44 M0,0v44",
      selected: null
    };
  },
  components: {
    Icono
  },
  computed: {
    getNotifications: function() {
      return this.$store.getters.getNotificaciones;
    }
  },
  methods: {
    vista: async function(notificacion) {
      await actualizarNotificacion(notificacion.id);
    },
    getDiff: function(date) {
      const now = moment().utc(),
        then = moment(date).utc(),
        duration = moment.duration(now.diff(then));
      return moment(Number(date)).format("MMM D YYYY h:mm a");
    }
  }
};
</script>
<template src="./Notificaciones.html"></template>
<style lang="scss" src="./Notificaciones.scss"></style>


// WEBPACK FOOTER //
// src/components/Notificaciones/Notificaciones.vue